"use client";

import { c as _c } from "react/compiler-runtime";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import type { ReactNode } from "react";
import { useEffect } from "react";
const reCaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
if (!reCaptchaKey) {
  console.warn("NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not set. reCaptcha will not work.");
}
export function CaptchaProvider(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  if (!reCaptchaKey) {
    let t2;
    if ($[1] !== children) {
      t2 = <>{children}</>;
      $[1] = children;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      async: true,
      defer: true,
      appendTo: "head"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey} scriptProps={t2} useRecaptchaNet={true} useEnterprise={false}>{children}</GoogleReCaptchaProvider>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp2() {
  if (!reCaptchaKey) {
    return;
  }
  const checkScript = _temp;
  const timeout = setTimeout(checkScript, 1000);
  return () => clearTimeout(timeout);
}
function _temp() {
  const script = document.querySelector("script[src*=\"recaptcha/api.js\"]");
  return Boolean(script);
}